"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fr_FR = _interopRequireDefault(require("../../date-picker/locale/fr_FR"));
var _default = _fr_FR["default"];
exports["default"] = _default;